import { useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { toast } from 'react-toastify';
import toastConfig from '../app/toast-config';
import { addNewSensorData, updateLiveReadings } from '../features/sensors/sensorSlice';
import { updateRules } from '../features/rules/ruleSlice';

function Websockets({setOutputStates, setWsConnected, setIsManualControlEnabled, setClient, setIsClientSet, setControlMode, setWaterLevelLow}) {
    const socketRef = useRef(null);
    const reconnectTimerRef = useRef(null);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const clientId = localStorage.getItem('clientId');
    const { currentDevice } = useSelector((state) => state.deviceData);

    const connectWebSocket = () => {
        console.log(`Client id from storage: ${clientId}`);
        var params = `isReactClient=true&user=${user._id}`;
        if(clientId !== null) params += `&reactClientId=${clientId}`;
        if(currentDevice !== null) params += `&currentDevice=${currentDevice.id}`;
        const baseURL = process.env.REACT_APP_SERVER_URL;
        const wsProtocol = baseURL.startsWith('https') ? 'wss' : 'ws';
        const host = baseURL.replace(/^https?:\/\//, '');
        const client = new W3CWebSocket(`${wsProtocol}://${host}/ws?${params}`);
        // setClient(client);

        client.onopen = () => {
            console.log('WebSocket Client connected.');
            toast.success('WebSocket Client connected.', toastConfig);
            setWsConnected(true);
    
            var json = {
                action: "get_output_states",
                user: user._id,
                deviceId: currentDevice.id
            }
            console.log(`Getting output states for ${json.deviceId} on websocket connect...`);
            client.send(JSON.stringify(json));
            setClient(client);
            setIsClientSet(true);
        };
    
        client.onmessage = (message) => {
            const data = JSON.parse(message.data);
            if(data.action === "update_id") {
                console.log(`Adding client id to the local storage: ${data.id}`);
                localStorage.setItem('clientId', data.id);
                console.log("Sending current device data to the server.");
                var json = {
                    action: "update_current_device",
                    id: data.id,
                    currentDevice: currentDevice.id
                }
                client.send(JSON.stringify(json));
            }
            else if(data.action === "output_states") {
                console.log("Received output states:");
                console.log(JSON.stringify(data.output_states));
                setOutputStates({
                    ...data.output_states
                });
                // setIsManualControlEnabled(true);
            }
            else if(data.action === "new_sensor_data") {
                console.log("Received sensor data:");
                console.log(JSON.stringify(data.sensor_data));
                if(data.scheduled) {
                    console.log("Scheduled data received, pushing to chart data");
                    dispatch(addNewSensorData(data.sensor_data));
                }
                else {
                    dispatch(updateLiveReadings(data.sensor_data));
                }
                // setIsManualControlEnabled(true);
            }
            else if(data.action === "get_rules_response") {
                console.log("Received rules.");
                // console.log(JSON.stringify(data.rules));
                dispatch(updateRules(data.rules));
            }
            else if(data.action === "set_control_mode_react_client") {
                console.log(`Received control mode change to ${data.mode}`);
                setControlMode(data.mode);
                // setIsManualControlEnabled(true);
            }
            else if(data.action === "set_control_mode_response") {
                const mode = data.mode; 
                setControlMode(mode);
            }
            else if(data.action === "error") {
                console.log(`Received error from server: ${data.message}`);
                if(data.message.includes("Water level low")) setWaterLevelLow(true)
                    else toast.error(`Error: ${data.message}`, toastConfig);
            }
        };
    
        client.onclose = () => {
            console.log("WebSocket Client disconnected.");
            toast.info("WebSocket Client disconnected.", toastConfig);
            setWsConnected(false);
            attemptReconnect();
        };
    
        client.onerror = (err) => {
            console.error('WebSocket error:', err);
            client.close(); // Force close on error
        }
    
        socketRef.current = client;
    };

    const attemptReconnect = () => {
        if (reconnectTimerRef.current) return; // Prevent multiple timers
        reconnectTimerRef.current = setTimeout(() => {
          connectWebSocket();
          reconnectTimerRef.current = null;
        }, 5000); // Try every 5 seconds
      };
    
      useEffect(() => {
        connectWebSocket();
    
        return () => {
          if (socketRef.current) {
            socketRef.current.close();
          }
          if (reconnectTimerRef.current) {
            clearTimeout(reconnectTimerRef.current);
          }
        };
      }, []);
    
    
    // setIsClientSet(true);
    return null;
}

export default Websockets